module.exports = __webpack_public_path__ + "img/xxx-coder.babb94ee.png";